enum Events {
  ADDED_TO_STAGE_EXECUTED = "Added to Stage - Guest added to Stage",
  ADDED_TO_STAGE_MAX_STREAMS = "Added to Stage - Maximum streams reached",
  ADDED_TO_STAGE_MOBILE_VIEW = "Added to Stage - Guest is on mobile view",
  ADDED_TO_STAGE_STREAMING_ACCEPTED = "Added to Stage - Accepted to Join Stage",
  ADDED_TO_STAGE_STREAMING_REQUESTED = "Added to Stage - Requested to Join Stage",
  AGENDA_ITEM_ADDED = "Agenda Item Added",
  ASPECT_RATIO_DEFAULT = "Aspect Ratio Toggled - Default",
  ASPECT_RATIO_ORIGINAL = "Aspect Ratio Toggled - Original",
  ATTENDEE_ONBOARDING_ABOUT_MIC_CAM_STEP = "Attendee Onboarding - About Mic Cam Check Step",
  ATTENDEE_ONBOARDING_ABOUT_PROFILE_STEP = "Attendee Onboarding - About Profiles Step",
  ATTENDEE_ONBOARDING_ADD_PROFILE_STEP = "Attendee Onboarding - Add Profile Step",
  ATTENDEE_ONBOARDING_EJECTED = "Attendee Onboarding - Ejected",
  ATTENDEE_ONBOARDING_PROFILE_IMAGE_UPLOADED = "Attendee Onboarding - Profile Image Uploaded",
  AUDIENCE_REACTION_CLICKED = "Audience Reaction Clicked",
  AUDIENCE_VIEW_CLOSED = "Audience View Closed",
  AUDIENCE_VIEW_OPENED = "Audience View Opened",
  BUSINESSCARD_MESSAGE_CLICK = "Clicked Message On BusinessCard",
  CAMERA_START_CLICK = "Camera Start Click",
  CAMERA_STOP_SUCCESS = "Camera Stop Success",
  CHANGELOG_HIDE = "Changelog Hide",
  CHANGELOG_INITIALIZATION_COMPLETE = "Changelog Initialization Complete",
  CHANGELOG_READ_MORE = "Changelog Read More",
  CHANGELOG_SHOW = "Changelog Show",
  CHANGELOG_SHOW_DETAILS = "Changelog Show Details",
  CLONE_EVENT_CLICKED = "Clone Event Clicked",
  DATA_DASHBOARD_CLOSED = "Data Dashboard Closed",
  DATA_DASHBOARD_OPENED = "Data Dashboard Opened",
  DATA_DASHBOARD_SUCCESS = "Data Dashboard Succeeded",
  DIRECTORY_CREATED = "Directory Created",
  DIRECTORY_DELETED = "Directory Deleted",
  DIRECTORY_UPDATED = "Directory Updated",
  EMBED_CONTENT_CREATE = "Created Embedded Content",
  EMBED_CONTENT_CREATE_START = "Start Creating Embedded Content",
  EVENT_BRANDING_LOGO_CHANGE = "Event Branding Logo Changed",
  EVENT_ENTERED = "Event Entered",
  EVENT_REGISTER_SIGNUP = "Event Register Signup",
  EVENT_REGISTRATION_CREATE_ACCOUNT = "Event Registration Create Account Step",
  EVENT_REGISTRATION_SUCCESS = "Event Registration Success",
  FIRESTORE_CONNECTION_ERROR = "Firestore Connection Error",
  GEARTEST_CAMERA_START = "Turned on Camera for Geartest",
  GEARTEST_MICROPHONE_START = "Turned on Mic for Geartest",
  GET_ATTENDEE_ON_STAGE = "Get Attendee OnStage",
  HAD_GOOD_CONVERSATION = "Had Good Conversation",
  HOST_ONBOARDING_FIRST_EVENT = "Host Onboarding - First Event Page Viewed",
  HOST_ONBOARDING_PRE_CONFIGURED_EVENT_CLICKED = "Host Onboarding - Pre-Configured Event Clicked",
  JOINED_EVENTS_VIEWED = "Joined Events Viewed",
  JOIN_EVENT_CLICKED_FROM_TEAMS = "Join Event Clicked From Teams",
  LINK_EVENTS_CLICKED = "Link Events Clicked",
  LOCK_TABLES_GUESTS_LOCKED_IN = "Lock Tables - Guests Locked In",
  LOCK_TABLES_TABLE_LOCKED = "Lock Tables - Table Locked",
  LOCK_TABLES_TABLE_UNLOCKED = "Lock Tables - Table Unlocked",
  LOGIN_SUCCESS = "Login Success",
  LOGIN_VIEWED = "Login Viewed",
  MAP_NAVIGATION_USER_LOCATED_SELF = "Map Navigation - Looked up own location",
  MAP_NAVIGATION_ZOOM_IN = "Map Navigation - Zoomed in",
  MAP_NAVIGATION_ZOOM_OUT = "Map Navigation - Zoomed out",
  MICROPHONE_START_CLICK = "Microphone Start Click",
  MICROPHONE_STOP_SUCCESS = "Microphone Stop Success",
  MORE_OPTIONS_VIEWED = "More Options Viewed",
  MOVED_FLOORS = "Moved Floors",
  MOVED_TABLES = "Moved Tables",
  NEW_EVENT_BUTTON_CLICKED = "New Event Button Clicked",
  NEW_EVENT_CREATED = "New Event Created",
  NEW_EVENT_VIEWED = "New Event Viewed",
  PRESENTATION_START = "Presentation Mode Start",
  PRESENTATION_STOP = "Presentation Mode Stop",
  PRESENT_CONTENT_BUTTON_CLICK = "Present Content Button Clicked",
  PRESENT_CONTENT_SHARED = "Present Content Shared",
  PUBLIC_CHAT_MESSAGE_SENT = "Public Chat Message Sent",
  RELATIONSHIP_STARTED = "Relationship Started",
  SCREEN_SHARE_START = "Share Screen Start",
  SHARE_TABLE_LINK = "Share Table Link Clicked",
  SHUFFLE_CLICKED = "Shuffle Attendees Clicked",
  SHUFFLE_COMPLETED = "Shuffle Attendees Completed",
  SHUFFLE_ERROR = "Shuffle Attendees Error",
  SHUFFLE_STARTED = "Shuffle Attendees Started",
  SIGNUP_VIEWED = "Signup Viewed",
  SPEAKERS_ADDED = "Speakers Added",
  SPONSORS_ADDED = "Sponsor Added",
  SPONSOR_BANNER_CLICKED = "Sponsor Banner Clicked",
  SUBSCRIPTION_CANCELLED = "Subscription Cancelled",
  SUBSCRIPTION_REACTIVATED = "Subscription Reactivated",
  SWITCH_TO_DESKTOP = "Switch to desktop experience",
  SWITCH_TO_MOBILE = "Switch to mobile experience",
  SYSTEM_CHECK = "System Check",
  SYSTEM_CHECK_EJECTED = "System Check Ejected",
  SHARE_VIDEO_DELAY_MANY_SEEKS = "Share Video - Too many times video needing sync",
  UPDATE_LIVE_USERS_COUNT_IN_EVENT = "Live Users Count",
  USER_IN_EVENT = "User in event",
  USER_ROLE = "User role",
  WHITE_BOARD_START = "Whiteboard Start",
  SHARE_VIDEO_DELAY_SYNC_ACTION = "Share Video - Delay detected, video synchronized",
}

export default Events;
